import { getFirestore, type Firestore } from 'firebase/firestore'
import { initialize } from '@/shared/services/firebase/Firebase'
import { parseJwt } from '@/shared/utils/parseJWT'
import { getFirebaseCustomToken } from '@/status/services/FirebaseHawkeye/getFirebaseCustomToken'
import {
  FirebaseProjects,
  getFirebaseConfiguration
} from '@/shared/services/firebase/getFirebaseConfiguration'

export class FirebaseHawkeye {
  private static firestoreInstance: Firestore

  public static async initialize({
    jobId,
    clientToken
  }: {
    jobId: string
    clientToken: string
  }): Promise<boolean> {
    try {
      const customToken = await getFirebaseCustomToken({
        jobId,
        apiKey: clientToken
      })
      const { claims } = parseJwt(customToken)

      const databaseId = `${claims.cluster}-hawkeye2`
      const config = getFirebaseConfiguration(FirebaseProjects.HAWKEYE)
      const { app, token } = await initialize({
        config,
        name: FirebaseProjects.HAWKEYE,
        customToken
      })

      sessionStorage.setItem('IL_cluster', claims.cluster)
      sessionStorage.setItem('IL_token', token)

      FirebaseHawkeye.firestoreInstance = getFirestore(app, databaseId)
      return true
    } catch (error) {
      return false
    }
  }

  public static getFirestore(): Firestore {
    return FirebaseHawkeye.firestoreInstance
  }
}
